import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import configVars from "../../config";
import TeamBars from "../../partials/Dashboard/Charts/TeamBars";
import OfflineColumnChart from "../../partials/HVI/OfflineColumnChart";
import OfflinePieChart from "../../partials/HVI/OfflinePieChart";
import { useTranslation } from "react-i18next";
// import { useTranslation } from "react-i18next";
// import { useCookies } from "react-cookie";

const SmiResults = (props) => {

    const { school, classroom } = useParams();
    const [graphData, setGraphData] = useState({});
    const [average, setAverage] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [loading, setLoading] = useState(false);
    const [redPeople, setRedPeople] = useState(0);
    const [yellowOnePeople, setYellowOnePeople] = useState(0);
    const [yellowTwoPeople, setYellowTwoPeople] = useState(0);
    const [greenPeople, setGreenPeople] = useState(0);

    const [classRooms, setClassRooms] = useState([]);
    const [translation] = useTranslation("translations");

    //const [translation] = useTranslation("translations");
	//const [cookies] = useCookies(["sc_user_lang"]);

    //const [userLang, setUserLang] = useState('sv');

    // useEffect(() => {

	// 	const queryString = window.location.search;
    // 	const urlParams = new URLSearchParams(queryString);

	// 	const chosenLang = urlParams.get("lang");
    // 	const savedLang = cookies?.sc_user_lang;

	// 	if ( chosenLang ) {
	// 		setUserLang( chosenLang );
	// 	} else if ( savedLang ) {
	// 		setUserLang( savedLang );
	// 	}

	// }, [cookies.sc_user_lang]);

    useEffect(() => {

        setLoading(true);

        (async () => {
				
            const response = await fetch(
                `${configVars.apiUrl}sustainchange/v1/getofflinesmi/?school=${school}&classroom=${classroom}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                }
            );
            
            const hviResponse = await response.json();

            if ( hviResponse ) {

                //console.log( hviResponse );

                if ( hviResponse.success === true ) {

                    let hviData = hviResponse.data.school_hvi;
                    let teamHvi = {
                        red: [0,0,0,0,0,0,0,0,0,0,0,0],
                        yellow: [0,0,0,0,0,0,0,0,0,0,0,0],
                        green: [0,0,0,0,0,0,0,0,0,0,0,0]
                    };

                    setTotalUsers( hviData.length );

                    let red = 0;
                    let yellowOne = 0;
                    let yellowTwo = 0;
                    let green = 0;

                    hviData.map( ( userData ) => {

                        let totalPoints = 0;

                        userData.map( (value, index ) => {

                            totalPoints = totalPoints + value;

                            if ( value === 0 || value === 1 || value === 2 ) {
        
                                teamHvi.red[index] = teamHvi.red[index] + 1;
                            }
            
                            if ( value === 3 || value === 4 ) {
            
                                teamHvi.yellow[index] = teamHvi.yellow[index] + 1;
                            }
            
                            if ( value === 5 || value === 6 ) {
            
                                teamHvi.green[index] = teamHvi.green[index] + 1;
                            }
                
                            return value;

                        });

                        if ( totalPoints > 12 && totalPoints <= 24 ) {
                            red = red + 1;
                        }

                        if ( totalPoints > 24 &&  totalPoints <= 41 ) {
                            yellowOne = yellowOne + 1; 
                        }

                        if ( totalPoints >= 60 ) {
                            green = green + 1;
                        }

                        if ( totalPoints >= 42 &&  totalPoints <= 59 ) {
                            yellowTwo = yellowTwo + 1;
                        }

                        return userData;
                        
                    });

                    teamHvi.red.map( (hvival, index) => (
                        teamHvi.red[index] = parseInt( (hvival*100)/hviData.length, 10 )
                    ));
                    teamHvi.yellow.map( (hvival, index) => (
                        teamHvi.yellow[index] = parseInt( (hvival*100)/hviData.length, 10 )
                    ));
                    teamHvi.green.map( (hvival, index) => (
                        teamHvi.green[index] = parseInt( (hvival*100)/hviData.length, 10 )
                    ));

                    setGraphData( teamHvi );
                    setAverage( hviResponse.data.hvi_average );

                    setRedPeople( red );
                    setYellowOnePeople( yellowOne );
                    setGreenPeople( green );
                    setYellowTwoPeople( yellowTwo );

                    //console.log( hviData );
                    //console.log( teamHvi );

                    if ( hviResponse.data?.class_rooms && hviResponse.data?.class_rooms.length > 0 ) {
                        setClassRooms( hviResponse.data?.class_rooms );
                    }

                }

                //console.log( hviResponse.data );

            }

            setLoading(false);

        })()

    }, [school, classroom]);

    const getHviColor = (count) => {
		let color = 'sy-red';

		if ( count > 24 && count < 60 ) {
			color = 'sy-yellow';
		}

		if ( count > 59 ) {
			color = 'dark-green';
		}

		return color;
	}

    return (
        <div className="results-wrap">

            {loading &&
                <div className="d-flex mt-3">
                    <div className="spinner-border" role="status" >
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            }
            <div className="hvi-wrap mt-5 d-flex align-items-center">
                <span className="h5 me-2">Vårt SMI (medelvärde):</span>
                <span className={`text-white h5 py-3 px-4 bg-${getHviColor(average)}`}>{average}</span>
            </div>
            <div className="hvi-wrap mt-3 d-flex align-items-center">
                <span className="h5 me-2">{translation('total_answered')}:</span>
                <span className="h5">{totalUsers}</span>
            </div>
            <div className="hvi-wrap mt-3">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <OfflineColumnChart totalUsers={totalUsers} data={[redPeople, yellowOnePeople, yellowTwoPeople, greenPeople]} title="Vårt SMI - antal per resultatkategori" />
                    </div>
                    <div className="col-12 col-lg-6">
                        <OfflinePieChart totalUsers={totalUsers} data={[redPeople, yellowOnePeople, yellowTwoPeople, greenPeople]} title="Vårt SMI - antal per resultatkategori (procent)" />
                    </div>
                </div>
            </div>
            <div className="hvi-wrap mt-5">
                <TeamBars hviValues={graphData} loading={loading}
                title="Vårt SMI - fördelning per fråga"
                questions={props?.questions} />
            </div>

            { classroom === 'results' && classRooms?.length > 0 &&
                 <div className="hvi-wrap mt-5">
                    <h3>{translation('see_class_results')}</h3>
                    
                    <ol className="mt-4">
                        {classRooms.map( (c,i) => {
                            return(
                                <li className="pb-2" key={i}>
                                    <Link to={`/smi/${school}/${c}/results`} className="btn btn-link p-0">{c}</Link>
                                </li>
                            );
                        })}
                    </ol>

                 </div>
            }

        </div>
    );
}

export default SmiResults